import { Button } from '../Button';

import type { ToastTextButtonProps } from './types';

const ToastTextButton = (props: ToastTextButtonProps) => {
  const { label, ...others } = props;

  if (!label) return null;

  return (
    <Button variant="inverse" size="sm" {...others}>
      {label}
    </Button>
  );
};

export default ToastTextButton;
